const SYNONYM_GROUPS: string[][] = [
	[
		'Uniklinik',
		'Uniklinikum',
		'Uni-Klinik',
		'Uni',
		'Universitätsklinikum',
		'Hochschulklinik',
		'Klinkum der Universität'
	],
	['KH', 'Krkh', 'Hosp', 'Krankenhaus', 'Hospital', 'Clinic'],
	['MVZ', 'Medizinisches Versorgungszentrum', 'Poliklinik'],
	['Inst', 'Dept', 'Institut', 'Institute', 'Abteilung'],
	['Hospital', 'Hôpital', 'Ospedale', 'Krankenhaus', 'Klinik', 'Ziekenhuis'],
	['Clinic', 'Clínica', 'Clinique', 'Clinica', 'Klinik', 'Kliniek'],
	['Center', 'Centre', 'Centro', 'Zentrum', 'Centrum'],
	['Institute', 'Instituto', 'Institut', 'Istituto', 'Instituut'],
	[
		'Foundation',
		'Fundación',
		'Fondation',
		'Fondazione',
		'Fundação',
		'Stiftung',
		'Stichting'
	],
	[
		'Polyclinic',
		'Policlínico',
		'Polyclinique',
		'Policlinico',
		'Policlínica',
		'Poliklinik',
		'Polikliniek'
	],
	[
		'Medical Center',
		'Centro Médico',
		'Centre Médical',
		'Centro Medico',
		'Medizinisches Zentrum',
		'Medisch Centrum'
	],
	[
		'Health Center',
		'Centro de Salud',
		'Centre de Santé',
		'Centro Sanitario',
		'Centro de Saúde',
		'Gesundheitszentrum',
		'Gezondheidscentrum'
	],
	['Sanatorium', 'Sanatorio', 'Sanatório'],
	['Dispensary', 'Dispensario', 'Dispensaire', 'Dispensário'],
	[
		'Maternity',
		'Obstetrics',
		'Maternidad',
		'Obstetricia',
		'Maternité',
		'Obstétrique',
		'Maternità',
		'Ostetricia',
		'Maternidade',
		'Obstetrícia',
		'Geburtshaus',
		'Kraamkliniek'
	],
	['Pharmacy', 'Farmacia', 'Pharmacie', 'Farmácia', 'Apotheke', 'Apotheek'],
	['Clinical', 'Clínico', 'Clinique', 'Clinico', 'Klinisch'],
	[
		'University',
		'Universidad',
		'Universitario',
		'Université',
		'Universitaire',
		'Università',
		'Universidade',
		'Universitário',
		'Universität',
		'Universitair'
	],
	['General', 'Général', 'Generale', 'Geral', 'Allgemein'],
	['Regional', 'Régional', 'Regionale'],
	['National', 'Nacional', 'Nazionale'],
	['Central', 'Centrale', 'Zentral'],
	['Provincial', 'Provinciale'],
	['Municipal', 'Comunale', 'Städtisch'],
	['Royal', 'Real', 'Reale', 'Königlich'],
	['Military', 'Militar', 'Militaire', 'Militare', 'Militär'],
	['Public', 'Público', 'Pubblico', 'Öffentlich'],
	['Private', 'Privado', 'Privé', 'Privato', 'Privat'],
	['Federal', 'Fédéral', 'Federale', 'Bundes'],
	['Pediatric', 'Pediátrico', 'Pédiatrique', 'Pediatrico', 'Kinder'],
	['Saint', 'St', 'San', 'Santo', 'Santa', 'Sainte', 'São'],
	[
		'Our Lady',
		'Nuestra Señora',
		'Notre Dame',
		'Nostra Signora',
		'Nossa Senhora'
	],
	['Holy', 'Sacred', 'Santo', 'Sagrado', 'Sacré', 'Sacro'],
	[
		'Sacred Heart',
		'Sagrado Corazón',
		'Sacré-Cœur',
		'Sacro Cuore',
		'Sagrado Coração'
	],
	['Cross', 'Cruz', 'Croix', 'Croce'],
	['Cardiology', 'Cardiología', 'Cardiologie', 'Cardiologia'],
	['Oncology', 'Oncología', 'Oncologie', 'Oncologia'],
	['Pediatrics', 'Pediatría', 'Pédiatrie', 'Pediatria'],
	['Surgery', 'Surgical', 'Cirugía', 'Chirurgie', 'Chirurgia', 'Cirurgia'],
	['Cancer', 'Cáncer', 'Cancro', 'Câncer'],
	['Heart', 'Corazón', 'Cœur', 'Cuore', 'Coração'],
	["Children's", 'Infantil', 'des Enfants', 'dei Bambini'],
	['Research', 'Investigación', 'Recherche', 'Ricerca', 'Pesquisa'],
	['Teaching', 'Docente', 'Enseignement', 'Insegnamento', 'Ensino'],
	[
		'Rehabilitation',
		'Rehabilitación',
		'Rééducation',
		'Riabilitazione',
		'Reabilitação'
	],
	['Emergency', 'Urgencias', 'Urgences', 'Pronto Soccorso', 'Emergência'],
	[
		'Care',
		'Healthcare',
		'Asistencia',
		'Soins',
		'Cura',
		'Assistenza',
		'Cuidados'
	],
	['Health', 'Salud', 'Santé', 'Salute', 'Saúde']
];

const WORD_SPLIT = /[\s-]+/;
const COMBINING_DIACRITICS = new RegExp('[\\u0300-\\u036f]', 'g');

const normalizeSynonymTerm = (term: string) =>
	term.normalize('NFD').replace(COMBINING_DIACRITICS, '').toLowerCase();

const SYNONYM_LOOKUP = new Map<string, Set<string>>();

SYNONYM_GROUPS.forEach(group => {
	const words = Array.from(
		new Set(
			group
				.flatMap(term => term.split(WORD_SPLIT))
				.map(normalizeSynonymTerm)
				.filter(Boolean)
		)
	);

	if (words.length < 2) return;

	words.forEach(word => {
		const synonyms = SYNONYM_LOOKUP.get(word) ?? new Set<string>();
		words.forEach(other => {
			if (other !== word) synonyms.add(other);
		});
		SYNONYM_LOOKUP.set(word, synonyms);
	});
});

export const getHcoNameSynonyms = (word: string): string[] =>
	Array.from(SYNONYM_LOOKUP.get(normalizeSynonymTerm(word)) ?? []);
